module.exports = __webpack_public_path__ + "static/media/icon-goto.cb712c64.svg";